import { Button, Dialog, IconButton, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface EnableAutomationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function EnableAutomationDialog({ open, onClose, onConfirm, isLoading }: EnableAutomationDialogProps) {
  const fields = [
    { title: "Business description", detail: "" },
    { title: "Secondary categories", detail: " (Only if Primary categories are added)" },
    { title: "Services", detail: "" },
    { title: "Attributes", detail: "" },
    { title: "GBP Posts", detail: " (Weekly once)" },
    { title: "Service area", detail: " (Weekly once)" }
  ];

  return (
    <Dialog open={open} onClose={() => !isLoading && onClose()} disableScrollLock>
      <div className="p-6 min-w-[600px] max-w-[600px] relative">
        <p className="text-primary font-semibold text-xl mb-2">
          Enable Automation
        </p>

        <p className="font-medium text-[15px] text-[#475467] mb-2">
          Enabling automation will allow the agent to optimize and make updates on your behalf. Please note that only the following fields will be automated:
        </p>

        <div className="bg-[#F9FAFB] rounded-xl p-4 mb-8 border border-[#EAECF0]">
          <ul className="space-y-3">
            {fields.map((field, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <CheckCircleIcon className="mt-0.5" sx={{ color: 'var(--color-secondary)', fontSize: 18 }} />
                <span className="text-[14px] text-primary font-medium">
                  {field.title}
                  {field.detail && (
                    <span className="text-[#667085] font-normal">{field.detail}</span>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex gap-2">
          <Button className='h-[40px] flex-1' variant="outlined" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button className='h-[40px] flex-1' variant="contained" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <CircularProgress size={20} sx={{ color: '#FFFFFF' }} />
            ) : (
              "Enable"
            )}
          </Button>
        </div>

        <div aria-label="dialog-close-btn" className="absolute top-0 right-0">
          <IconButton
            aria-label="close"
            className="hover:rounded-lg"
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 2,
              height: '40px',
              padding: '8px',
              paddingRight: '8px'
            }}
            onClick={onClose}
            disabled={isLoading}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </div>
    </Dialog>
  );
}
